export default "__VITE_ASSET__c1e43d9f__"